import React from "react";

import { Form, FormMessage } from "lib/index";
import OrderCustomerDetailsFormSection from "modules/orders/OrderCustomerDetailsFormSection";

export default class NewOrderCustomerDetailsForm extends React.PureComponent {
  handleSubmit(event) {
    event.preventDefault();
    this.props.onSave();
  }

  render() {
    const { order, valid, loading, errors, onOrderUpdate, onValidate } = this.props;
    return (
      <Form onSubmit={this.handleSubmit.bind(this)} error={!valid}>
        {!!errors.base && <FormMessage error={errors.base} />}

        <OrderCustomerDetailsFormSection order={order} errors={errors} onChange={onOrderUpdate} onBlur={onValidate} />

        <button type="submit" disabled={loading} hidden />
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/NewOrderModal/NewOrderCustomerDetailsForm/NewOrderCustomerDetailsForm.jsx